import { Model, Attr } from 'spraypaint';
import ApplicationRecord from '../ApplicationRecord';

@Model()
export default class TotpResetConfirmation extends ApplicationRecord {
  static jsonapiType = 'totp-reset-confirmations';

  @Attr() uid: string;

  @Attr() token: string;

  @Attr() password: string;
}
